import React from "react";
import ReactDOM from "react-dom/client";
import "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
//Estilo global.
import "@/assets/plugins/font-awesome/css/font-awesome.min.css";
import "@/assets/fonts/Linearicons/Linearicons/Font/demo-files/demo.css";
import "@/assets/plugins/bootstrap/css/bootstrap.min.css";
import "@/assets/plugins/owl-carousel/assets/owl.carousel.min.css";
import "@/assets/plugins/owl-carousel/assets/owl.theme.default.min.css";
import "@/assets/plugins/slick/slick/slick.css";
import "@/assets/plugins/nouislider/nouislider.min.css";
//----->
import "@/assets/plugins/lightGallery-master/dist/css/lightgallery.min.css";
import "@/assets/plugins/jquery-bar-rating/dist/themes/fontawesome-stars.css";
import "@/assets/plugins/select2/dist/css/select2.min.css";
//------<
import "@/assets/css/style.css";
import "@/Styles/App.css";
//
import "@/Components/Carrusel/HomeCarousel/StyleCarouselBtn.css";
//
import "@/Styles/App.css";
import "@/Styles/MenuHeaderMovil.css";
//swiper
import "@/Components/Header/HeaderThreeHome.css";
import "@/Styles/BannerHome2.css";
//
import RouterNavigate from "./Router/RouterNavigate.js";
import { ContextHomeProvider } from "./Context/Home/ContextHomeProvider.js";
import { ContextHeaderProvider } from "./Context/Header/ContextHeaderProvider.js";
import { ContextCheckoutProvider } from "./Context/Checkout/ContextCheckoutProvider.js";
import ContextCategorieProvider from "./Context/Categorie/ContextCategorieProvider.js";

const rootElement = document.getElementById("root") as HTMLElement;

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ContextHomeProvider>
      <ContextHeaderProvider>
        <ContextCategorieProvider>
          <ContextCheckoutProvider>
            <RouterNavigate />
          </ContextCheckoutProvider>
        </ContextCategorieProvider>
      </ContextHeaderProvider>
    </ContextHomeProvider>
  </React.StrictMode>
);
